import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
  Menu,
  MenuItem,
} from "@mui/material";
import "./parameter.scss";
import Label from "../../../components/Label/Label";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openRow, setOpenRow] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedRow, setSelectedRow] = useState();


  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleExpand = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const toggleSection = (rowId, section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [section]: !prev[rowId]?.[section],
      },
    }));
  };

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        className="uop-table-container"
        sx={{ scrollbarGutter: "auto" }}
      >
        <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
          <TableHead positon="sticky" top={0} className="table-header">
            <TableRow>
              <TableCell className="uop-table-header-cell">Table Name </TableCell>
              <TableCell className="uop-table-header-cell">Created By</TableCell>
              <TableCell className="uop-table-header-cell">Created On</TableCell>
              <TableCell className="uop-table-header-cell">Updated By</TableCell>
              <TableCell className="uop-table-header-cell">Last Updated</TableCell>
              <TableCell className="uop-table-header-cell">Status</TableCell>
              <TableCell className="uop-table-header-cell" sx={{ width: '10%' }} align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {
              // openData &&

              data?.data?.results?.map((row) => (
                <>
                  <TableRow key={row}>

                    <TableCell>{row.table_name}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.created_by}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.created_at}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.updated_by}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.updated_at}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      <Chip
                        label={row.status}
                        className={`status-chip ${row.status?.includes("active")
                          ? "status-chip-color-green"
                          : "status-chip-color-gray"
                          }`}
                      />
                    </TableCell>
                    <TableCell sx={{ width: '10%' }} align="right">
                      <IconButton size="small" onClick={(e) => handleClick(e, row)}>
                        <MoreVertIcon />
                      </IconButton>

                    </TableCell>
                  </TableRow>
                </>
              ))
            }
            {!data?.loading && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <Label color="textSecondary" text={"No data found"}></Label>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              boxShadow: "none",
              border: "1px solid #ccc",
              padding: 0,
              minWidth: "100px",
              backgroundColor: "transparent",
            },
          }}
          MenuListProps={{
            sx: {
              padding: 0,
              backgroundColor: "white",
              borderRadius: 0,
            },
          }}
        >
          {moreOption?.map((option) => (
            <MenuItem
              sx={{ py: 0.4 }}
              key={option}
              onClick={(e) => {
                e.stopPropagation();
                handleMenuOption(option, selectedRow);
                handleClose();
              }}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </TableContainer>
    </Box>
  );
}
